export const CONVERSATION_EVENTS = Object.freeze({
  EXECUTED_A_MACRO: 'Executed a macro',
  SENT_MESSAGE: 'Sent a message',
  SENT_PRIVATE_NOTE: 'Sent a private note',
  INSERTED_A_CANNED_RESPONSE: 'Inserted a canned response',
  TRANSLATE_A_MESSAGE: 'Translated a message',
  INSERTED_A_VARIABLE: 'Inserted a variable',
  INSERTED_AN_EMOJI: 'Inserted an emoji',
  INSERTED_A_TOOL: 'Inserted a tool',
  USED_MENTIONS: 'Used mentions',
  SEARCH_CONVERSATION: 'Searched conversations',
  APPLY_FILTER: 'Applied filters in the conversation list',
  CHANGE_PRIORITY: 'Assigned priority to a conversation',
});

export const ACCOUNT_EVENTS = Object.freeze({
  ADDED_TO_CANNED_RESPONSE: 'Used added to canned response option',
  ADDED_A_CUSTOM_ATTRIBUTE: 'Added a custom attribute',
  ADDED_AN_INBOX: 'Added an inbox',
  OPEN_MESSAGE_CONTEXT_MENU: 'Opened message context menu',
  OPENED_NOTIFICATIONS: 'Opened notifications',
  MARK_AS_READ_NOTIFICATIONS: 'Marked notifications as read',
  OPEN_CONVERSATION_VIA_NOTIFICATION: 'Opened conversation via notification',
});

export const LABEL_EVENTS = Object.freeze({
  CREATE: 'Created a label',
  UPDATE: 'Updated a label',
  DELETED: 'Deleted a label',
  APPLY_LABEL: 'Applied a label',
});

// REPORTS EVENTS
export const REPORTS_EVENTS = Object.freeze({
  DOWNLOAD_REPORT: 'Downloaded a report',
  FILTER_REPORT: 'Used filters in the reports',
});

// CONTACTS PAGE EVENTS
export const CONTACTS_EVENTS = Object.freeze({
  APPLY_FILTER: 'Applied filters in the contacts list',
  SAVE_FILTER: 'Saved a filter in the contacts list',
  DELETE_FILTER: 'Deleted a filter in the contacts list',

  APPLY_SORT: 'Sorted contacts list',
  SEARCH: 'Searched contacts list',
  CREATE_CONTACT: 'Created a contact',
  MERGED_CONTACTS: 'Used merge contact option',
  IMPORT_MODAL_OPEN: 'Opened import contacts modal',
  IMPORT_FAILURE: 'Import contacts failed',
  IMPORT_SUCCESS: 'Imported contacts successfully',
});

// CAMPAIGN EVENTS
export const CAMPAIGNS_EVENTS = Object.freeze({
  OPEN_NEW_CAMPAIGN_MODAL: 'Opened new campaign modal',
  CREATE_CAMPAIGN: 'Created a new campaign',
  UPDATE_CAMPAIGN: 'Updated a campaign',
  DELETE_CAMPAIGN: 'Deleted a campaign',
});

export const LUMERAI_EVENTS = Object.freeze({
  // Editor funnel events
  EDITOR_AI_MENU_OPENED: 'LumerAI: Editor AI menu opened',
  GENERATION_FAILED: 'LumerAI: Generation failed',
  AI_ASSISTED_MESSAGE_SENT: 'LumerAI: AI-assisted message sent',

  // Rewrite events (with operation attribute in payload)
  REWRITE_USED: 'LumerAI: Rewrite used',
  REWRITE_APPLIED: 'LumerAI: Rewrite applied',
  REWRITE_DISMISSED: 'LumerAI: Rewrite dismissed',

  // Summarize events
  SUMMARIZE_USED: 'LumerAI: Summarize used',
  SUMMARIZE_APPLIED: 'LumerAI: Summarize applied',
  SUMMARIZE_DISMISSED: 'LumerAI: Summarize dismissed',

  // Reply suggestion events
  REPLY_SUGGESTION_USED: 'LumerAI: Reply suggestion used',
  REPLY_SUGGESTION_APPLIED: 'LumerAI: Reply suggestion applied',
  REPLY_SUGGESTION_DISMISSED: 'LumerAI: Reply suggestion dismissed',

  // Follow-up events
  FOLLOW_UP_SENT: 'LumerAI: Follow-up sent',

  // Label suggestions
  LABEL_SUGGESTION_APPLIED: 'LumerAI: Label suggestion applied',
  LABEL_SUGGESTION_DISMISSED: 'LumerAI: Label suggestion dismissed',
});

export const COPILOT_EVENTS = Object.freeze({
  SEND_SUGGESTED: 'Copilot: Send suggested message',
  SEND_MESSAGE: 'Copilot: Sent a message',
  USE_LUMERAI_RESPONSE: 'Copilot: Used lumerai response',
});

export const SNOOZE_EVENTS = Object.freeze({
  NLP_SNOOZE_APPLIED: 'Applied snooze via text-to-date input',
});

export const GENERAL_EVENTS = Object.freeze({
  COMMAND_BAR: 'Used commandbar',
});

export const INBOX_EVENTS = Object.freeze({
  OPEN_CONVERSATION_VIA_INBOX: 'Opened conversation via inbox',
  MARK_NOTIFICATION_AS_READ: 'Marked notification as read',
  MARK_ALL_NOTIFICATIONS_AS_READ: 'Marked all notifications as read',
  MARK_NOTIFICATION_AS_UNREAD: 'Marked notification as unread',
  DELETE_NOTIFICATION: 'Deleted notification',
  DELETE_ALL_NOTIFICATIONS: 'Deleted all notifications',
});

export const SLA_EVENTS = Object.freeze({
  CREATE: 'Created an SLA',
  UPDATE: 'Updated an SLA',
  DELETED: 'Deleted an SLA',
});

export const LINEAR_EVENTS = Object.freeze({
  CREATE_ISSUE: 'Created a linear issue',
  LINK_ISSUE: 'Linked a linear issue',
  UNLINK_ISSUE: 'Unlinked a linear issue',
});

export const YEAR_IN_REVIEW_EVENTS = Object.freeze({
  MODAL_OPENED: 'Year in Review: Modal opened',
  NEXT_CLICKED: 'Year in Review: Next clicked',
  SHARE_CLICKED: 'Year in Review: Share clicked',
});

export const SESSION_EVENTS = Object.freeze({
  LIMIT_HIT: 'Session limit reached at login',
  REVOKED_FROM_PROFILE: 'Revoked an active session',
});

export const ONBOARDING_EVENTS = Object.freeze({
  ACCOUNT_DETAILS_VISITED: 'Onboarding: Account details visited',
  ACCOUNT_DETAILS_COMPLETED: 'Onboarding: Account details completed',
  INBOX_SETUP_VISITED: 'Onboarding: Inbox setup visited',
  INBOX_SETUP_COMPLETED: 'Onboarding: Inbox setup completed',
  INBOX_SETUP_SKIPPED: 'Onboarding: Inbox setup skipped',
});
